import { StepHeading } from './step-heading';

type WaitingForLposProps = {
  companionConnected: boolean;
  companionName: string;
};

export function WaitingForLpos({ companionConnected, companionName }: WaitingForLposProps) {
  return (
    <div className="flex flex-col gap-4" data-testid="waiting-for-lpos">
      <StepHeading>Receiving in LiquorPOS</StepHeading>

      <p className="text-base leading-relaxed text-gray-700">
        We've sent your receiving file to LiquorPOS on{' '}
        <span className="font-semibold">{companionName}</span>. Start the receiving in LiquorPOS
        using the steps below.
      </p>

      <ol className="flex flex-col gap-2 text-base leading-relaxed list-decimal pl-6 text-gray-700">
        <li>
          Open LiquorPOS on <span className="font-semibold">{companionName}</span>.
        </li>
        <li>
          Go to <i>Activities &gt; Receive Products &gt; Receive Miscellaneous</i>, or click{' '}
          <img
            src="/receive.png"
            alt="LiquorPOS Receive button"
            className="inline-block h-4 w-4 mb-[0.5px]"
          />{' '}
          in the toolbar.
        </li>
        <li>Follow the LiquorPOS prompts to complete the receiving.</li>
      </ol>

      <p className="text-base leading-relaxed text-gray-700">
        This page will update automatically once receiving is complete in LiquorPOS.
      </p>

      {!companionConnected && (
        <p className="text-sm text-gray-500">Uploader offline — check the store computer.</p>
      )}
    </div>
  );
}
